document.addEventListener('DOMContentLoaded', () => {
    const countDownAnnouncementBar = document.querySelector('[js-announcement-bar]');
    if(countDownAnnouncementBar){
        const section = document.querySelector('.sale-countdown-section');
        const headerSpace = document.querySelector('data-header-space');
        if (!section) return;

        const year = parseInt(section.dataset.year, 10);
        const month = parseInt(section.dataset.month, 10) - 1;
        const day = parseInt(section.dataset.day, 10);
        const hour = parseInt(section.dataset.hour, 10);
        const minute = parseInt(section.dataset.minute, 10);

        const targetDate = new Date(year, month, day, hour, minute, 0).getTime();

        const wrapper = section.querySelector('.countdown-wrapper');
        const daysEl = section.querySelector('[data-days]');
        const hoursEl = section.querySelector('[data-hours]');
        const minutesEl = section.querySelector('[data-minutes]');
        const secondsEl = section.querySelector('[data-seconds]');

        function updateCountdown() {
        const now = Date.now();
        const distance = targetDate - now;

        if (distance <= 0) {
        countDownAnnouncementBar.classList.add('sales-countdown-ends');
        clearInterval(interval);
        return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.textContent = days;
        hoursEl.textContent = hours.toString().padStart(2, '0');
        minutesEl.textContent = minutes.toString().padStart(2, '0');
        secondsEl.textContent = seconds.toString().padStart(2, '0');
        }

        updateCountdown();
        const interval = setInterval(updateCountdown, 1000);

        let lastScrollY = window.scrollY;

        function handleScrollDirection() {
        const currentScrollY = window.scrollY;

        if (currentScrollY === 0) {
            countDownAnnouncementBar.classList.add('announcement-bar-noscroll');
            countDownAnnouncementBar.classList.remove('announcement-bar-up', 'announcement-bar-down');
        } else {
            countDownAnnouncementBar.classList.remove('announcement-bar-noscroll');

            if (currentScrollY > lastScrollY) {
            countDownAnnouncementBar.classList.add('announcement-bar-down');
            countDownAnnouncementBar.classList.remove('announcement-bar-up');
            } else if (currentScrollY < lastScrollY) {
            countDownAnnouncementBar.classList.add('announcement-bar-up');
            countDownAnnouncementBar.classList.remove('announcement-bar-down');
            }
        }

        lastScrollY = currentScrollY;
        }

        window.addEventListener('scroll', handleScrollDirection, { passive: true });
        let touchStartY = 0;
        window.addEventListener('touchstart', (e) => {
        touchStartY = e.touches[0].clientY;
        }, { passive: true });

        window.addEventListener('touchmove', (e) => {
        const touchCurrentY = e.touches[0].clientY;

        if (window.scrollY === 0) {
            countDownAnnouncementBar.classList.add('announcement-bar-noscroll');
            countDownAnnouncementBar.classList.remove('announcement-bar-up', 'announcement-bar-down');
        } else {
            countDownAnnouncementBar.classList.remove('announcement-bar-noscroll');

            if (touchCurrentY > touchStartY) {
            countDownAnnouncementBar.classList.add('announcement-bar-up');
            countDownAnnouncementBar.classList.remove('announcement-bar-down');
            } else if (touchCurrentY < touchStartY) {
            countDownAnnouncementBar.classList.add('announcement-bar-down');
            countDownAnnouncementBar.classList.remove('announcement-bar-up');
            }
        }
        }, { passive: true });
    }
  });